import React from 'react';
import { Head } from '@inertiajs/react';

// Renders the meta tags computed server-side (see ApplicationController /
// SpreadsController set_meta_tags) into the document <head> via Inertia's
// Head manager. This is the single place that turns the `meta_tags` prop
// into real <title>, description, canonical, Open Graph, Twitter and
// JSON-LD tags so they show up for Google and social previews.
export default function Seo({ meta }) {
  if (!meta) return null;

  const {
    title,
    description,
    keywords,
    canonical,
    og = {},
    twitter = {},
    schema,
  } = meta;

  const ogTitle = og.title || title;
  const ogDescription = og.description || description;

  return (
    <Head>
      {title && <title>{title}</title>}
      {description && (
        <meta head-key="description" name="description" content={description} />
      )}
      {keywords && (
        <meta head-key="keywords" name="keywords" content={keywords} />
      )}
      {canonical && (
        <link head-key="canonical" rel="canonical" href={canonical} />
      )}

      {ogTitle && (
        <meta head-key="og:title" property="og:title" content={ogTitle} />
      )}
      {ogDescription && (
        <meta head-key="og:description" property="og:description" content={ogDescription} />
      )}
      <meta head-key="og:type" property="og:type" content={og.type || 'website'} />
      {canonical && (
        <meta head-key="og:url" property="og:url" content={canonical} />
      )}

      <meta
        head-key="twitter:card"
        name="twitter:card"
        content={twitter.card || 'summary_large_image'}
      />
      {ogTitle && (
        <meta head-key="twitter:title" name="twitter:title" content={ogTitle} />
      )}
      {ogDescription && (
        <meta head-key="twitter:description" name="twitter:description" content={ogDescription} />
      )}

      {schema && (
        <script
          head-key="schema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      )}
    </Head>
  );
}
